import axios from 'axios';
import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';

export default {
  // 刷新token
  TokenRefresh: async function () {
    const res = await axios.post(apis.TokenRefresh);
    if (res.data.code === 0) {
      const accessToken = res.data.data.accessToken || '';
      const timeOut = Number(moment(Date.now()).format('X')) + res.data.data.expiresIn;
      Cookies.set('token', accessToken, { path: '/' });
      Cookies.set('tokenTimeOut', timeOut, { path: '/' });
    } else {
      Cookies.remove('token', { path: '/' });
      Cookies.remove('tokenTimeOut', { path: '/' });
    }
  },
  // 用户信息
  LoginUserInfo: async function (store) {
    const res = await axios.get(apis.LoginUser);
    store.commit('USERINFO', res.data.data.userInfo);
  },
};
